<template lang="pug">
v-form.component-form(ref="componentForm" @submit.prevent="submitComponent")
  v-card
    v-card-title
      .subtitle-1 {{ component.title }}
      v-spacer
      v-btn(icon small title="Make a copy of this component" @click="copyComponent")
        v-icon(small) mdi-content-copy

    v-card-text
      v-text-field.component-title(v-model="title" :rules="[rules.required]" label="Title" placeholder="Artifact Cards" dense outlined)
      template-size-editor(v-if="componentTemplate" :template="componentTemplate")

    v-card-actions
      v-spacer
      v-btn(small @click="submitComponent") Done
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { computedVModelUpdate } from '../util/component_helper'
  import TemplateSizeEditor from '../template/TemplateSizeEditor.vue'

  export default {
    props: {
      component: { required: true }
    },

    components: { TemplateSizeEditor },

    data() {
      return {
        rules: {
          required: value => !!value || 'Required.'
        }
      }
    },

    computed: {
      ...mapGetters(["activeGame", "findComponentTemplate"]),

      title: computedVModelUpdate("component", "patchComponent", "title"),

      componentTemplate() {
        return this.component && this.findComponentTemplate(this.component)
      }
    },

    methods: {
      ...mapActions(["patchComponent", "copyGameComponent"]),

      copyComponent() {
        const copyComponent = {
          ...this.component,
          title: `${this.component.title} Copy`,
          quantityProperty: null,
          worksheetFirstRow: null,
          worksheetLastRow: null,
        }

        this.copyGameComponent({ game: this.activeGame, component: copyComponent })
        this.$emit("close-dialog")
      },

      submitComponent() {
        if(this.$refs.componentForm.validate()) {
          this.$emit("close-dialog")
        }
      }
    }
  }
</script>
